import { ButtonSize } from "../Button";
import { EmptyStateSize } from "../EmptyState";

export function mapEmptyStateSizeToButtonSize(size: EmptyStateSize | undefined): ButtonSize | undefined {
  switch (size) {
    case "sm":
      return "sm";
    case "md":
      return "md";
    case "lg":
      return "lg";
  }
  return undefined;
}